// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1899":"32a81be2","2255":"3b1e880a","3918":"32a81be2","4621":"32a81be2","5081":"32a81be2","6092":"32a81be2","9238":"3b1e880a"}[chunkId] + ".chunk.css";
};